/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_FInputs */



/**
* | output |
* | --- |
* | "Program F" |
*
* @param {Subtitle_Export_Program_FInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_f = /** @type {((inputs?: Subtitle_Export_Program_FInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_FInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Programme F")
	if (locale === "de") return /** @type {LocalizedString} */ ("Programm F")
	if (locale === "it") return /** @type {LocalizedString} */ ("Programma F")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Программа F")
	if (locale === "es") return /** @type {LocalizedString} */ ("Programa F")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("程序 F")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プログラムF")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम एफ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Programa F")
	return /** @type {LocalizedString} */ ("Program F")
});